<script setup>

import CustomLeftMenu from "@/components/NewPC/CustomLeftMenu.vue";
import CustomMenu from "@/components/NewPC/CustomMenu.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import RightLightning from "@/components/NewPC/RightLightning.vue";
import {getArticles} from "@/api/common";
import {onMounted,ref} from "vue";
import {useRouter} from "vue-router";
import GiftEntry from "@/components/NewPC/GiftEntry.vue";
import {useTgaStore} from "@/store/tga";
import useAccount from "@/store/account";
const tga = useTgaStore()
const accountStore = useAccount();
const router = useRouter();
const articles = ref([]);

const fetchArticles = () => {
  getArticles({type: 1}).then((res) => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      articles.value = res.data.data;
    }
  })
}

const handleJumpDetail = row => {
  window.open(`${window.location.origin}/news-detail?id=${row.id}&type=1`);
}
const handleJumpHome = () => {
  router.push('/')
}
onMounted(() => {
  fetchArticles()

  tga.tgaLogin("202504_GUANWANG", accountStore.getterAccount() ? accountStore.getterAccount():'未绑定');
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_page_exposure',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "新闻"
  })
})


</script>

<template>
<div class="news_block">
  <custom-menu :active="1" />
  <div class="content">
    <img src="@/assets/newPc/topup/topup_logo.png" @click="handleJumpHome" alt="" class="logo_icon">
    <div class="block">
      <div class="banner">
        <img src="@/assets/newPc/news_banner.png" alt="">
        <div class="tags">
          <span>S25</span>
        </div>
      </div>
      <div class="articles">
        <div>
          <div class="articles_item" v-for="item of articles" @click="handleJumpDetail(item)">{{item.title}}</div>
        </div>
<!--        <button>下载游戏抢鲜体验</button>-->
      </div>
    </div>
  </div>

  <gift-entry class="gift_entry" />
  <custom-left-menu type="News" class="left_menu" />
  <left-lightning class="left_lightning" />
  <right-lightning class="right_lightning" />
</div>
</template>

<style scoped lang="scss">
@import "@/style/fonts.scss";

.news_block {
  width: 100vw;
  height: 100vh;
  background: transparent url("@/assets/newPc/page_bg.png") no-repeat center center;
  background-size: cover;
  position: relative;
  scrollbar-width: none;

  .content {
    width: 100vw;
    height: 100vh;
    background: transparent url("@/assets/newPc/news_header_bg.png") no-repeat top center;
    background-size: contain;
    display: flex;
    justify-content: center;
    padding-top: 16.2890625vw;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    .logo_icon {
      position: absolute;
      left: 2.265625vw;
      top: 2.03125vw;
      width: 7.3046875vw;
      height: 4.0234375vw;
    }
    .block {
      width: 65vw;
      height: 22.65625vw;
      background-color: #fff;

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .banner {
        position: relative;

        img {
          width: 40vw;
          height: 22.65625vw;
        }

        .tags {
          position: absolute;
          top: -0.390625vw;
          right: -0.15625vw;
          width: 10.390625vw;
          height: 3.59375vw;
          background: transparent url("@/assets/newPc/news_banner_tag_bg.png") no-repeat top center;
          background-size: contain;

          span {
            font-family: 'YouSheBiaoTiHei';
            font-size: 2.421875vw;
            color: #fff;
            display: flex;
            justify-content: center;
            line-height: 1;
            margin-left: 1vw;
            margin-top: 0.190625vw;
          }
        }
      }
      .articles {
        padding-top: 3.046875vw;
        padding-left: 2.890625vw;
        box-sizing: border-box;
        width: 25vw;
        height: 22.65625vw;

        &_item {
          padding-left: 2.03125vw;
          color: #717171;
          font-family: 'SourceHanSansCN-Regular';
          font-size: 0.9765625vw;
          height: 1.25vw;
          line-height: 1.25vw;
          margin-bottom: 1.015625vw;
          position: relative;
          cursor: pointer;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 1.25vw;
            height: 1.25vw;
            background: transparent url("@/assets/newPc/news_item_icon.png") no-repeat center center;
            background-size: cover;
          }

          &::after {
            content: '';
            position: absolute;
            top: 1.48vw;
            left: 0.5509375vw;
            display: block;
            width: 1px;
            height: 0.625vw;
            background-color: #717171;
          }

          &:last-child {
            &::after {
              background-color: transparent;
            }
          }
        }

        button {
          border: none;
          width: 9.453125vw;
          height: 2.421875vw;
          background: transparent url("@/assets/newPc/news_button_bg.png") no-repeat center center;
          background-size: cover;
          font-family: 'SourceHanSansCN-Bold';
          font-size: 0.9375vw;
          color: #fff;
        }
      }
    }
  }

  .left_menu {
    position: absolute;
    top: 16.09375vw;
    left: 3.0078125vw;
    z-index: 1;
  }

  .gift_entry {
    position: absolute;
    top: 29.5703125vw;
    right: 1.640625vw;
    z-index: 1;
    width: 9.0625vw;
    height: 6.171875vw;
  }

  .left_lightning {
    position: absolute;
    left: 0;
    top: 28.59375vw;
  }

  .right_lightning {
    position: absolute;
    right: 0;
    top: 8.671875vw;
  }
}
</style>